export default "__VITE_ASSET__mwwDjR1o__"